module.exports = __webpack_public_path__ + "img/logo_agrotis.4fb1a25b.png";